import { IonContent } from '@ionic/react';
import styled from 'styled-components';

export const StyledContent: any = styled(IonContent)`
  ::part(background) {
    background: inherit;
  }
`;
